<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>

      <Sidebar></Sidebar>

      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Edit Country</h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Country</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="country"
                          v-model="item.country"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Slug</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          class="form-control"
                          name="slug"
                          v-model="item.slug"
                        />
                      </div>
                    </div>
                    <div class="form-group mb-4">
                      <div class="main">
                        <div class="flex">
                          <!-- Map Display here -->
                          <div class="map-holder">
                            <div id="map"></div>
                          </div>

                          <!-- Coordinates Display here -->
                          <div class="dislpay-arena">
                            <div class="coordinates-header">
                              <h3>Current Coordinates</h3>
                              <p>Latitude: {{ center[0] }}</p>
                              <p>Longitude: {{ center[1] }}</p>
                            </div>

                            <div class="coordinates-header">
                              <h3>Current Location</h3>

                              <div class="form-group">
                                <input 
                                  type="text"
                                  class="location-control"
                                  :value="location"
                                  readonly
                                />
                                <button
                                  type="button"
                                  class="copy-btn"
                                  @click="copyLocation"
                                >
                                  Copy
                                </button>
                              </div>

                              <button
                                type="button"
                                :disabled="loading"
                                :class="{ disabled: loading}"
                                class="location-btn"
                                @click="getLocation"
                              >
                                Get Location
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Image</label>
                      <div class="col-md-12 border-bottom p-0">
                        <img
                          v-bind:src="previewImage"
                          class="uploading-image"
                        />
                        <input
                          type="file"
                          accept="image/jpeg"
                          @change="uploadImage"
                        />
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Status</label>
                      <div class="col-md-12 border-bottom p-0">
                        <select
                          name="status"
                          v-model="item.status"
                          class="form-control"
                        >
                          <option
                            v-for="option in options"
                            v-bind:key="option.value"
                            v-bind:value="option.key"
                          >
                            {{ option.value }}
                          </option>
                        </select>
                        <span>Selected: {{ item.status }}</span>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <div class="col-sm-12">
                        <input
                          type="submit"
                          class="btn btn-primary"
                          value="Submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  </body>
</template>

<script>

import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import axios from 'axios'
import { db } from '../../main'

export default{
     name: 'Edit',
        data(){
            return{
				loading: false,
      location: "",
      access_token: "pk.eyJ1IjoiaW50cm9zYnMiLCJhIjoiY2t2MHU4bWE4M2h1OTMwczcxMm03YmM0eSJ9.ocDaQEjuvL3rUd50oaB6Qw",
      center: [0, 0],
      map: {},
                item:{},
                previewImage:'',
                selected: '',
				latt:'',
				langg:'',
                options: [],
            }
        },
        components:{

            'Header':Header,
            'Sidebar':Sidebar,
            'Footer':Footer,

        },

        created: function(){
            this.getItem();
            this.getCompanies();
        },
		mounted() {
    this.createMap();
  },

        methods: {
						    createMap() {
      try {
        mapboxgl.accessToken = this.access_token;
        this.map = new mapboxgl.Map({
          container: "map",
          style: "mapbox://styles/mapbox/streets-v11",
          center: this.center,
          zoom: 11,
        });
        let geocoder =  new MapboxGeocoder({
            accessToken: this.access_token,
            mapboxgl: mapboxgl,
            marker: false,
          });
        this.map.addControl(geocoder);
        geocoder.on("result", (e) => {
          const marker = new mapboxgl.Marker({
            draggable: true,
            color: "#D80739",
          })
            .setLngLat(e.result.center)
            .addTo(this.map);
          this.center = e.result.center;
          marker.on("dragend", (e) => {
            this.center = Object.values(e.target.getLngLat());
          });
        });
      } catch (err) {
        console.log("map error", err);
      }
    },
    async getLocation() {
      try {
        this.loading = true;
        const response = await axios.get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.center[0]},${this.center[1]}.json?access_token=${this.access_token}`
        );
        this.loading = false;
        this.locations = response.data.features[0].place_name;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    copyLocation() {
      if (this.locations) {
        navigator.clipboard.writeText(this.locations);
        alert("Location Copied")
      }
      return;
    },

            uploadImage(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                    this.previewImage = e.target.result;
                    console.log('dd');
                };
            },
            getItem()
            {
                var id = this.$route.params.id;

                db.collection('countries').doc(id).get().then((doc) => {
                    console.log(doc.data());
                    this.item = doc.data();
                    this.previewImage = doc.data().image;
                    //this.previewImage = doc.data().image;
                })
            },
            getCompanies()
            {
                this.options = [
                    {
                        key: '1',
                        value:'Publish'
                    },
                    {
                        key: '2',
                        value:'Unpublish'
                    }
                ];

            },

            submit()
            {
				  			var theSlug =this.item.country;
				theSlug = theSlug.toLowerCase();
				theSlug = theSlug.replace(/\s+/g, '-');
				// Replace Ampersand With Dash and Spaces
			theSlug = theSlug.replace(/&/g, "-and-")
				this.slug = theSlug;

				if(this.center[0] !=""){
					this.latt = this.center[0];
					this.langg = this.center[1];
				}else{
					this.latt = this.item.lat;
					this.langg = this.item.lang;
				}

                var id = this.$route.params.id;
                var  date = new Date().toLocaleString();//.toISOString().slice(0, 10);
                console.log(this.item);
                db.collection("countries")
                .doc(id)

                .update({
                  country: this.item.country,
				  lng:this.latt,
				  lat:this.langg,
                  slug: this.item.slug,
                  status: this.item.status,
                  image:this.previewImage,
                  modified: date,
                })
                .then(() => {
                  console.log("Document successfully updated!");
                  //this.readEmployees();
                  this.$toasted.success('Success, Updated Successfully!', {
                    icon : 'check',
                     //icon : 'error_outline'
                 })
                 this.$router.push('/countries/index');

                })
                .catch((error) => {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
                });
            }
        }
    }
</script>
<style>
.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.map-holder {
  width: 65%;
}
#map {
  height: 70vh;
}
.dislpay-arena {
  background: #ffffff;
  box-shadow: 0px -3px 10px rgba(0, 58, 78, 0.1);
  border-radius: 5px;
  padding: 20px 30px;
  width: 25%;
}
.coordinates-header {
  margin-bottom: 50px;
}
.coordinates-header h3 {
  color: #1f2a53;
  font-weight: 600;
}
.coordinates-header p {
  color: rgba(13, 16, 27, 0.75);
  font-weight: 600;
  font-size: 0.875rem;
}
.form-group {
  position: relative;
}
.location-control {
  height: 30px;
  background: #ffffff;
  border: 1px solid rgba(31, 42, 83, 0.25);
  box-shadow: 0px 0px 10px rgba(73, 165, 198, 0.1);
  border-radius: 4px;
  padding: 0px 10px;
  width: 90%;
}
.location-control:focus {
  outline: none;
}
.location-btn {
  margin-top: 15px;
  padding: 10px 15px;
  background: #d80739;
  box-shadow: 0px 4px 10px rgba(73, 165, 198, 0.1);
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 600;
}
.location-btn:focus {
  outline: none;
}
.disabled {
  background: #db7990;
  cursor: not-allowed;
}
.copy-btn {
  background: #f4f6f8 0% 0% no-repeat padding-box;
  border: 1px solid #f4f6f8;
  border-radius: 0px 3px 3px 0px;
  position: absolute;
  color: #5171ef;
  font-size: 0.875rem;
  font-weight: 500;
  height: 30px;
  padding: 0px 10px;
  cursor: pointer;
  right: 3.5%;
  top: 5%;
}
.copy-btn:focus {
  outline: none;
}
.dislpay-arena[data-v-0d798840] {
  width: 30%;
}
.coordinates-header h3[data-v-0d798840] {
  font-size: 20px;
}
</style>
